import { render } from "./CustomerContractsModal.vue?vue&type=template&id=6d64a420&scoped=true"
import script from "./CustomerContractsModal.vue?vue&type=script&lang=js"
export * from "./CustomerContractsModal.vue?vue&type=script&lang=js"

import "./CustomerContractsModal.vue?vue&type=style&index=0&id=6d64a420&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d64a420"],['__file',"src/components/Customers/CustomerContracts/CustomerContractsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d64a420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d64a420', __exports__)) {
    api.reload('6d64a420', __exports__)
  }
  
  module.hot.accept("./CustomerContractsModal.vue?vue&type=template&id=6d64a420&scoped=true", () => {
    api.rerender('6d64a420', render)
  })

}


export default __exports__